/**
 * Returns  returns correct browser CSS3 transition end event.
 * @see https://jonsuh.com/blog/detect-the-end-of-css-animations-and-transitions-with-javascript/
 * @return {string}
 */

function onTransitionEnd() {
  var t,
    el = document.createElement("fakeelement");

  var transitions = {
    "transition"      : "transitionend",
    "OTransition"     : "oTransitionEnd",
    "MozTransition"   : "transitionend",
    "WebkitTransition": "webkitTransitionEnd"
  }

  for (t in transitions){
    if (el.style[t] !== undefined){
      return transitions[t];
    }
  }
}

/**
 * Slide an element down like jQuery's slideDown function using CSS3 transitions.
 * @see https://gist.github.com/ludder/4226288
 * @param  {element}  el
 * @param  {string}   timing
 * @return {void}
 */
export function slideDown(el, timing) {
  timing = timing || '300ms ease';

  // Get element height
  el.style.webkitTransition = 'none';
  el.style.transition = 'none';
  el.style.visibility = 'hidden';
  el.style.maxHeight = 'none';
  var height = el.offsetHeight + 'px';
  el.style.removeProperty('visibility');
  el.style.maxHeight = '0';
  el.style.overflow = 'hidden';

  // Begin transition
  el.style.webkitTransition = 'max-height ' + timing + ', opacity ' + timing + '';
  el.style.transition = 'max-height ' + timing + ', opacity ' + timing + '';
  var endSlideDown = function() {
    el.style.removeProperty('-webkit-transition');
    el.style.removeProperty('transition');
    el.removeEventListener(onTransitionEnd(), endSlideDown);
  };
  requestAnimationFrame(function() {
    el.addEventListener(onTransitionEnd(), endSlideDown);
    el.style.maxHeight = height;
    el.style.opacity = '1';
  });
}

/**
 * Slide an element up like jQuery's slideUp function using CSS3 transitions.
 * @see https://gist.github.com/ludder/4226288
 * @param  {element}  el
 * @param  {string}   timing
 * @return {void}
 */
export function slideUp(el, timing) {
  timing = timing || '300ms ease';

  // Get element height
  el.style.webkitTransition = 'none';
  el.style.transition = 'none';
  var height = el.offsetHeight + 'px';
  el.style.maxHeight = height;
  el.style.overflow = 'hidden';

  // Begin transition
  el.style.webkitTransition = 'max-height ' + timing + ', opacity ' + timing + '';
  el.style.transition = 'max-height ' + timing + ', opacity ' + timing + '';
  var endSlideDown = function() {
    el.style.removeProperty('-webkit-transition');
    el.style.removeProperty('transition');
    el.removeEventListener(onTransitionEnd(), endSlideDown);
  };
  requestAnimationFrame(function() {
    el.style.maxHeight = '0';
    el.style.opacity = '0';
  });
}


// WEBPACK FOOTER //
// ./catalog/accordion/accordion-animation.js